import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, FlexView, Row, Separator, Text } from '@cuemath/comps';
import { FieldWrapper, renderFormField, Message, getFormFields } from 'modules/form';
import Tooltip from 'comps/tooltip';
import styled, { css } from 'styled-components';
import {
  getInputChangeMethod,
  getOnChangeMethod,
  demoIncentiveReasonFields,
  MODAL_CONFIRMATION_ACTIONS,
} from 'constants/form';
import {
  patch as patchDemoIncentiveData,
  post as postDemoIncentiveData,
  invalidateItem,
} from 'actions/demo-incentives';
import {
  OtherOption,
  PaymentLinkInfoDetails,
  ReasonsTitle,
  INCENTIVE_ACTIONS,
  ACTIONS_LABEL,
} from 'constants/demo-incentive';
import { getFormDefaults, validateIsEmpty } from 'modules/form';
import { bindActionCreators } from 'redux';
import { closeModal } from 'actions/modal';
import { connect } from 'react-redux';
import { get as getConfig } from 'actions/configs';
import { Info } from 'styled-icons/octicons/Info';
import { store } from 'redux-rest-reducer';
import COLORS from 'constants/colors';
import { Input } from 'modules/form';
import { dateObjToEpoch } from 'utils';

const DEMO_INCENTIVE_KEY = 'god_admin_demo_incentive';
const PAYMENT_ID = `Payment ID `;
const PAYMENT_ID_FIELD_PARAM = 'payment_id';
const OTHER_REASON = 'other_reason';
const REASON = 'reason';
const CREATE = 'Create';
const START_DATE = 'startDate';
const START_TIME = 'startTime';

const SpanWrapper = styled.span`
  cursor: pointer;
`;

const InputContainer = styled(Input)`
  width: 250px;
`;

const Asterisk = styled.label`
  color: red;
`;

const Label = styled.label`
  min-width: ${({ profileView }) => `${profileView ? '35%' : '40%'}`};
  padding-left: ${({ profileView }) => `${profileView ? '10px' : '4px'}`};
`;

const ButtonWrapper = styled(Button)`
  cursor: pointer;
  background: ${COLORS.DARK_PINK};
  :hover {
    background: ${COLORS.DARK_PINK};
  }
  ${({ isConfirmBtnGreen }) =>
    isConfirmBtnGreen &&
    css`
      background: ${COLORS.DARK_GREEN};
      :hover {
        background: ${COLORS.DARK_GREEN};
      }
    `}
`;

const Fields = styled.div`
  width: 80%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ profileView }) => `${profileView ? '10px' : '12px'}`};
`;

class TableModal extends PureComponent {
  constructor(props) {
    super(props);
    const { filledData } = props;

    this.state = {
      formData: {},
      errorText: null,
      message: null,
      form: getFormDefaults(filledData, demoIncentiveReasonFields),
      formFields: getFormFields(demoIncentiveReasonFields),
      demoIncentiveDataPatch: store.patch(),
      invalidatedPatch: false,
      invalidatedPost: false,
      startDate: '',
      startTime: '',
    };

    demoIncentiveReasonFields.forEach(field => {
      const methodName = getOnChangeMethod(field.name);
      this[methodName] = this.onChange.bind(this, field.name);
    });
  }

  static getDerivedStateFromProps(props, state) {
    const { actions, demoIncentiveData, filledData } = props;
    const { student_id, teacher_id: teacherId } = filledData || {};
    const { demoIncentiveDataPatch, invalidatedPatch, invalidatedPost } = state;

    const query = {
      student_id,
      grouped_by_student: false,
    };

    const demoIncentivesPatch = store.patch(
      demoIncentiveData,
      demoIncentiveDataPatch.id,
      query,
    );
    const demoIncentivesPost = store.post(demoIncentiveData, teacherId);

    const newState = {};

    const { resolved: patchResolved } = demoIncentivesPatch || {};
    const { resolved: postResolved } = demoIncentivesPost || {};
    const { __ERROR__: patchError, isPatched, isPatchingFailed } = patchResolved || {};
    const { message } = patchError || {};
    const { __ERROR__: postError, isCreated, isCreatingFailed } = postResolved || {};
    const { message: postErrorMsg } = postError || {};
    newState.errorText = null;

    if (patchResolved) {
      if (isPatchingFailed) {
        newState.errorText = message;
        newState.demoIncentivesPatch = demoIncentivesPatch;
      }

      if (isPatched && teacherId && invalidatedPatch) {
        actions.invalidateItem(teacherId, query);
        newState.invalidatedPatch = false;
        actions.closeModal();
        newState.errorText = null;
      }
    }

    if (postResolved) {
      if (isCreated && invalidatedPost) {
        actions.invalidateItem(teacherId, query);
        newState.invalidatedPost = false;
        actions.closeModal();
        newState.errorText = null;
      }
      if (isCreatingFailed && invalidatedPost) {
        newState.errorText = postErrorMsg;
      }
    }

    return newState;
  }

  componentDidMount() {
    const { actions } = this.props;
    this.setState({ errorText: null }, () => {
      actions.getConfig(DEMO_INCENTIVE_KEY);
    });
  }

  onChange = (key, value) => {
    const { form, errorText } = this.state;
    const newForm = { ...form };

    newForm[key] = value;

    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;

    this.setState(() => ({ ...stateChanges }));
  };

  onDateTimeChange = (event, name) => {
    console.log('date', event, name);
    this.setState({
      errorText: null,
      [name]: event,
    });
  };

  onOptionChange = (key, value) => {
    const { form, errorText } = this.state;
    const newForm = { ...form };

    newForm[key] = value;
    const stateChanges = { form: newForm };
    if (errorText) stateChanges.errorText = null;

    const UpdateFieldsValues = (fields, value) => {
      fields.map(field => (newForm[field] = value));
    };

    let fieldsToBeClear = [];

    if (key === PAYMENT_ID_FIELD_PARAM) {
      stateChanges.bandId = value;
      fieldsToBeClear = [REASON, OTHER_REASON];
      UpdateFieldsValues(fieldsToBeClear, null);
    }
    if (key === REASON) {
      fieldsToBeClear = [OTHER_REASON];
      UpdateFieldsValues(fieldsToBeClear, null);
    }

    this.setState(() => ({ ...stateChanges }));
  };

  confirmModal = showDate => {
    const { actions, heading, demoIncentiveId, createDemoBtn, filledData } = this.props;
    const { teacher_id: teacherId } = filledData || {};
    const { form, demoIncentiveDataPatch, startDate, startTime } = this.state;
    const { reason = [], other_reason: otherReason, payment_id: paymentId } = form || {};
    const { student_id: studentId } = filledData || {};
    const { ADD_ENROLLMENT_INCENTIVE } = ACTIONS_LABEL;
    const addEnrolIncentive = heading === ADD_ENROLLMENT_INCENTIVE;
    const PaymentIdNotEntered =
      heading === ADD_ENROLLMENT_INCENTIVE && validateIsEmpty(paymentId);
    const ReasonNotSelected = !reason || !reason.length;
    const OtherReasonIsSelected = !ReasonNotSelected && reason.includes(OtherOption);
    const OtherReasonNotEntered = OtherReasonIsSelected && validateIsEmpty(otherReason);
    this.setState({ errorText: null });

    if (showDate && !startDate) {
      this.setState({ errorText: 'Please select date' });
      return;
    }
    if (showDate && !startTime) {
      this.setState({ errorText: 'Please select time' });
      return;
    }
    if (OtherReasonIsSelected && !!otherReason) {
      reason.push(otherReason);
    }
    if (PaymentIdNotEntered) {
      this.setState({ errorText: 'Please enter Payment ID' });
      return;
    }
    if (ReasonNotSelected) {
      this.setState({ errorText: 'Please select at least one reason' });
      return;
    }
    if (OtherReasonNotEntered) {
      this.setState({ errorText: 'Please enter your other reason' });
      return;
    }

    const splittedDate = startDate.split('-');
    const splittedTime = startTime.split(':');

    let action_data = {
      reason,
    };

    const datesAreSelected =
      splittedDate &&
      splittedDate.length === 3 &&
      splittedTime &&
      splittedTime.length === 2;

    const dateTimeValue =
      datesAreSelected &&
      dateObjToEpoch(
        new Date(
          splittedDate[0], //Year
          splittedDate[1] - 1, //Month
          splittedDate[2], //Date
          splittedTime[0], //Hour
          splittedTime[1], //Min
        ),
      );

    if (createDemoBtn) {
      if (dateTimeValue) {
        const query = {
          demo_date: dateTimeValue,
          student_id: studentId,
          reason,
        };
        this.setState({ invalidatedPost: true }, () => {
          actions.postDemoIncentiveData(teacherId, query);
        });
      } else {
        this.setState({ errorText: 'Please enter correct date and time' });
        return;
      }
    } else {
      if (addEnrolIncentive) {
        action_data['payment_link_id'] = paymentId;
      }
      const action = INCENTIVE_ACTIONS[heading];

      const query = {
        action,
        action_data,
      };

      this.setState({ invalidatedPatch: true }, () => {
        actions.patchDemoIncentiveData(demoIncentiveDataPatch.id, demoIncentiveId, query);
      });
    }
  };

  renderButtons = () => {
    const { heading } = this.props;
    const { CONFIRM } = MODAL_CONFIRMATION_ACTIONS;

    return (
      <FlexView flexDirection="row" alignItems="center" justifyContent="center">
        <ButtonWrapper
          isConfirmBtnGreen={heading.includes('Add')}
          label={CONFIRM}
          onClick={() => this.confirmModal(heading.includes(CREATE))}
        />
      </FlexView>
    );
  };

  enrolIncentiveReason = (fieldName, isPaymentIdNecessary) => {
    const { heading } = this.props;

    const isReasonField = fieldName === REASON;
    const isOtherReasonField = !isReasonField && !isPaymentIdNecessary;
    const isOtherReasonWithPaymtId = fieldName === OTHER_REASON && isPaymentIdNecessary;

    if (isReasonField) return ReasonsTitle(heading);
    if (isOtherReasonField) return ReasonsTitle('Other');
    if (isOtherReasonWithPaymtId) return ReasonsTitle('Other');

    return null;
  };

  renderAllFormFields = () => {
    const { formFields, form } = this.state;
    const { reason } = form || {};
    const { configs, createDemoBtn, heading } = this.props;
    const { ADD_ENROLLMENT_INCENTIVE } = ACTIONS_LABEL;
    const isPaymentIdNecessary = heading === ADD_ENROLLMENT_INCENTIVE;
    const isOtherReasonSelected =
      reason &&
      Array.isArray(reason) &&
      reason.length > 0 &&
      reason.includes(OtherOption);

    const PaymentIdTooltip = () => {
      return (
        <>
          {PAYMENT_ID}
          <SpanWrapper>
            <Tooltip title={PaymentLinkInfoDetails} position="bottom" width="200px">
              <Info size={14} />
            </Tooltip>
          </SpanWrapper>
        </>
      );
    };

    const dateTimeWrapper = () => {
      const { startDate, startTime } = this.state;

      const DateTimeArray = [
        {
          label: `Demo Date`,
          name: startDate,
          type: 'date',
          value: startDate || '',
        },
        {
          label: `Demo Time`,
          name: startTime,
          type: 'time',
          value: startTime || '',
        },
      ];

      return (
        <FieldWrapper width="100%">
          <Fields>
            <Label>
              Demo Date<Asterisk>*</Asterisk>
            </Label>
            <InputContainer
              name={START_DATE}
              type="date"
              required={true}
              value={startDate || ''}
              onChange={e => this.onDateTimeChange(e, 'startDate')}
            />
          </Fields>
          <Fields>
            <Label>
              Demo Time<Asterisk>*</Asterisk>
            </Label>
            <InputContainer
              name={START_TIME}
              type="time"
              required={true}
              value={startTime || ''}
              onChange={e => this.onDateTimeChange(e, 'startTime')}
            />
          </Fields>
        </FieldWrapper>
      );
    };

    const onlyReasonField = [...formFields];
    let renderFormFields = [];

    if (isPaymentIdNecessary && isOtherReasonSelected) {
      renderFormFields = onlyReasonField;
    }

    if (isPaymentIdNecessary && !isOtherReasonSelected) {
      renderFormFields = onlyReasonField.slice(0, onlyReasonField.length - 1);
    }

    if (isOtherReasonSelected && !isPaymentIdNecessary) {
      renderFormFields = onlyReasonField.slice(1, onlyReasonField.length);
    }
    if (!isOtherReasonSelected && !isPaymentIdNecessary) {
      renderFormFields = onlyReasonField.slice(1, 2);
    }

    const configReady = !!(configs && Object.keys(configs).length);
    let allOptions = [];
    if (configReady) {
      allOptions = configs[heading.toLowerCase()].map(configData => {
        return {
          label: configData,
          value: configData,
        };
      });
    }

    return (
      <>
        {createDemoBtn && dateTimeWrapper()}
        <FieldWrapper width="100%">
          {renderFormFields.map(field => {
            const { label: placeholder, name, required } = field || {};

            return renderFormField({
              ...field,
              value: form[name],
              label:
                field.name === PAYMENT_ID_FIELD_PARAM
                  ? PaymentIdTooltip()
                  : this.enrolIncentiveReason(name, isPaymentIdNecessary),
              onChange: this[getInputChangeMethod(field)],
              required,
              placeholder,
              choices: allOptions,
            });
          })}
        </FieldWrapper>
      </>
    );
  };

  render() {
    const { heading } = this.props;
    const { errorText } = this.state;

    return (
      <FlexView justifyContent="center" alignItems="center" gap={16} gutter>
        <Text justifyContent="center" alignItems="center" size="large" weight="bold">
          {heading}
        </Text>
        <Separator height={30} transparent />
        {errorText && <Message error={true}>{errorText}</Message>}
        <Separator transparent height={30} />
        <Row justifyContent="center" alignItems="center">
          {' '}
          <Col xs={12}>{this.renderAllFormFields()}</Col>
        </Row>
        <Separator transparent height={30} />
        {this.renderButtons()}
        <Separator transparent height={25} />
      </FlexView>
    );
  }
}

TableModal.propTypes = {
  actions: PropTypes.shape({
    closeModal: PropTypes.func.isRequired,
    getConfig: PropTypes.func.isRequired,
    patchDemoIncentiveData: PropTypes.func.isRequired,
    postDemoIncentiveData: PropTypes.func.isRequired,
  }).isRequired,
  configs: PropTypes.shape({}),
  demoIncentiveId: PropTypes.string,
  filledData: PropTypes.shape({}).isRequired,
  heading: PropTypes.string.isRequired,
  invalidateItem: PropTypes.func,
};

TableModal.defaultProps = {
  configs: {},
  demoIncentiveId: null,
  invalidateItem: () => {},
};

export default connect(
  ({ configs, demoIncentiveData }) => ({
    configs: store.get(configs, DEMO_INCENTIVE_KEY)
      ? store.get(configs, DEMO_INCENTIVE_KEY).data
      : null,
    demoIncentiveData: demoIncentiveData,
  }),
  dispatch => ({
    actions: bindActionCreators(
      {
        closeModal,
        getConfig,
        patchDemoIncentiveData,
        postDemoIncentiveData,
        invalidateItem,
      },
      dispatch,
    ),
  }),
)(TableModal);
